import { useCallback } from 'react';
import {ExposureConfig, SaveExposuresConfigPayload} from "../../ExposuresConfiguration/types";
import {usePost, UsePostParams} from "../../../../api";

const ENDPOINT = '/insights/saveConfigurations';

export type UseSaveExposuresConfigurationParams = UsePostParams<SaveExposuresConfigPayload, {}>;

const useSaveExposuresConfiguration = (usePostParams: UseSaveExposuresConfigurationParams) => {
    const { post, ...rest } = usePost<SaveExposuresConfigPayload, ExposureConfig>(usePostParams);

    const saveExposuresConfigurations = useCallback(
        (params: SaveExposuresConfigPayload) => post(ENDPOINT, params),
        [post]
    );

    return {
        ...rest,
        saveExposuresConfigurations
    };
};

export default useSaveExposuresConfiguration;